<bp-hl-area-container name="Boden">
	<div class="touch-form">
		<!-- Bodenform Section -->
		<div class="form-section-header">Bodenform</div>

		<!-- Bodenform: pro Glied HBF oben + (Präfix + FBF) unten als vertikaler Block;
		     Trenner zwischen Gliedern vertikal mittig; Buttons + Suffix + (G) einmal rechts -->
		<div class="form-row">
			<div class="form-input-cell multi bodenform-row">
				<ng-container *ngFor="let bf of data.header.bodenform.bf; let i = index; trackBy: trackByIndex">
					<wd-list-input *ngIf="i > 0" class="bodenform-trenner" name="BodenformTrenner" options="/|//" [(model)]="bf.trenner"></wd-list-input>
					<div class="bodenform-pair">
						<!-- Knoepfe im Feld statt (i) (Nutzer-Entscheidung 28.09.2026):
						     Katalog an der HBF, Auswahlliste an der FBF. -->
						<wd-typeahead [(model)]="bf.hbf" label="Hauptbodenform" name="Hauptbodenform[i]" [filter]="hauptbodenformFilter(data.type, i)" placement="bottom" [extraSuggestions]="moorHBFSuggestions" [focusFirst]="false">
							<button feldKnopf type="button" class="btn btn-outline-secondary feld-knopf" title="Im Bodenformenkatalog nachschlagen" aria-label="Im Bodenformenkatalog nachschlagen" (click)="nachschlagen.zeigeSteckbrief(bf.hbf)"><i class="bi bi-journal-text"></i></button>
						</wd-typeahead>
						<div class="bodenform-fbf-line">
							<wd-text-input class="prefix-narrow" [(model)]="bf.prefix" label="Präfix" name="FBFPrefix[i]"></wd-text-input>
							<wd-typeahead #fbfFeld [(model)]="bf.fbf" label="Feinbodenform" name="Feinbodenform[i]" [filter]="feinbodenformFilter(bf.hbf)" [hbfFilter]="bf.hbf" placement="bottom" (hbfSelected)="bf.hbf = $event" [hbfAusFreitext]="hbfAusMoorFbf" [acceptOtherValues]="true" [otherValuesRegex]="moorFBFRegex" [otherValuesRegexMessage]="moorFBFRegexMessage" [extraSuggestions]="moorFBFSuggestionsFor(bf.hbf)" [focusFirst]="false">
								<button feldKnopf type="button" class="btn btn-outline-secondary feld-knopf" title="Feinbodenform aus der Liste wählen" aria-label="Feinbodenform aus der Liste wählen" (click)="nachschlagen.waehleFeinbodenform(fbfFeld, bf.fbf, bf.hbf)"><i class="bi bi-list-ul"></i></button>
							</wd-typeahead>
						</div>
					</div>
				</ng-container>
				<div class="btn-group bodenform-buttons">
					<button *ngIf="data.header.bodenform.bf.length > 1" class="btn btn-danger btn-sm" (click)="removeBodenformPair()"><i class="bi bi-trash"></i></button>
					<button *ngIf="canAddBodenformPair()" class="btn btn-info btn-sm" (click)="addBodenformPair()"><i class="bi bi-plus"></i></button>
				</div>
				<wd-typeahead class="bodenform-suffix" [(model)]="data.header.bodenform.suffix" label="Suffix" name="BodenformSuffix" placement="bottom"></wd-typeahead>
				<wd-checkbox-input *ngIf="reliktGInteractive(); else reliktGLockedTpl" class="narrow" name="ReliktG" label="(G)" [(model)]="data.header.bodenform.reliktG"></wd-checkbox-input>
				<ng-template #reliktGLockedTpl>
					<wd-checkbox-input class="narrow reliktg-locked" name="ReliktG" label="(G)" [model]="false" title="(G) nur bei anhydromorpher Hauptbodenform aktivierbar"></wd-checkbox-input>
				</ng-template>
			</div>
		</div>

		<!-- Humusform / Vegetationsformengruppe -->
		<div class="form-row" *ngIf="hatHumusForm(data) || hatVegetationsformengruppe(data)">
			<div class="form-input-cell multi no-scroll">
				<wd-an-typeahead *ngIf="hatHumusForm(data)" name="Humusform" label="Humusform" [(model)]="data.header.humusform.aufnahmeFlaeche"></wd-an-typeahead>
				<wd-typeahead *ngIf="hatVegetationsformengruppe(data)" name="Vegetationsformengruppe" label="Veg.-Gruppe" [(model)]="data.header.vegetationsformengruppe"></wd-typeahead>
			</div>
		</div>

		<!-- Die Humusauflage (Ol/Of/Oh) steht seit 03.09.2026 oben in der
		     Horizontfolge (Maske "Substrate/Horizonte"), denn sie gehört ins
		     Tiefenprofil, nicht in eine eigene Ecke der Boden-Maske. -->

		<!-- Wasserhaushalt links, Bodenchemie rechts (Nutzer-Entscheidung 11.09.2026):
		     beides kurze Felder, die nebeneinander passen. Ab 800px Fensterbreite,
		     also auch auf dem Tablet hochkant; darunter (Telefon) untereinander wie
		     bisher. Die engste Reihe braucht rund 250px, ein Feld kann naemlich nie
		     schmaler sein als sein Etikett ("Grundwasserform"). -->
		<div class="boden-messwerte-nebeneinander">
			<div>
				<!-- Wasserhaushalt Section -->
				<div class="form-section-header">Wasserhaushalt</div>
				<div class="form-row">
					<div class="form-input-cell multi">
						<wd-number-input name="Saugsaum" label="Saugsaum [cm]" [(model)]="data.extendedHeader.saugsaum"></wd-number-input>
						<!-- Unter oder über Flur: Knopf im Feld, über Flur negativ gespeichert; bei Filz
						     zählt Flur ab Oberkante Ol (flur-tiefe.ts). -->
						<bp-flur-tiefe-input name="Spiegeltiefe" label="Spiegeltiefe [cm]" [(model)]="data.extendedHeader.spiegelTiefe" [versatz]="filzVersatz()"></bp-flur-tiefe-input>
					</div>
				</div>
				<div class="form-row">
					<div class="form-input-cell multi no-scroll">
						<wd-text-input name="Wasserform2" label="Stauwasserform" [(model)]="data.header.wasserstufe2" [superscript]="true"></wd-text-input>
						<span class="inline-label">/</span>
						<wd-text-input name="Wasserform" label="Grundwasserform" [(model)]="data.header.wasserstufe" [superscript]="true"></wd-text-input>
						<!-- Das Entwaesserungsverhalten stand hier ein zweites Mal und ist
						     seit 11.09.2026 raus (Nutzer-Entscheidung): Es gehoert an die
						     Substrat-/Horizont-Tabelle, aus der es vorgeschlagen wird, und
						     dort steht es (substrate-horizonte.component.html, dieselbe
						     Bindung extendedHeader.entwaesserungsverhalten). -->
					</div>
				</div>
			</div>

			<div>
				<!-- Bodenchemie Section -->
				<div class="form-section-header">Bodenchemie</div>
				<div class="form-row">
					<div class="form-input-cell multi equal-width">
						<wd-list-input name="V-Wert-Vermutet" label="V-Wert geschätzt" [(model)]="data.extendedHeader.vWertSaugsaumVermutet"></wd-list-input>
						<wd-number-input name="V-Wert" label="V-Wert Labor [%]" [(model)]="data.extendedHeader.vWertSaugsaum"></wd-number-input>
					</div>
				</div>
				<div class="form-row">
					<div class="form-input-cell multi equal-width">
						<wd-number-input name="pH1" label="pH₁ (H₂O)" [(model)]="data.extendedHeader.ph!.wert1"></wd-number-input>
						<wd-list-input name="PHOrt" label="Ort₁" [(model)]="data.extendedHeader.ph!.ort1"></wd-list-input>
						<span class="inline-label">|</span>
						<wd-number-input name="pH2" label="pH₂ (H₂O)" [(model)]="data.extendedHeader.ph!.wert2"></wd-number-input>
						<wd-list-input name="PHOrt" label="Ort₂" [(model)]="data.extendedHeader.ph!.ort2"></wd-list-input>
					</div>
				</div>
			</div>
		</div>

		<!-- Standort Section: STFG komplett in einer Zeile -->
		<div class="form-section-header">Stamm-Standortformengruppe</div>
		<div class="form-row">
			<div class="form-input-cell multi equal-width">
				<wd-typeahead name="Stammfeuchtestufe1" label="Hydromorphiegruppe" [(model)]="data.extendedHeader.stfg.stammFeuchteStufe.first" placement="top"></wd-typeahead>
				<wd-typeahead name="Nährkraftstufe" label="Nährkraft" [(model)]="data.extendedHeader.stfg.naehrkraftStufe" placement="top"></wd-typeahead>
				<wd-typeahead name="Stammfeuchtestufe2" label="Stammfeuchte" [(model)]="data.extendedHeader.stfg.stammFeuchteStufe.second" placement="top"></wd-typeahead>
				<wd-typeahead name="Substratgruppe" label="Substrat" [(model)]="data.extendedHeader.stfg.substratGruppe" placement="top"></wd-typeahead>
				<wd-typeahead [(model)]="data.header.bodenform.suffix" label="Suffix" name="BodenformSuffix" placement="top"></wd-typeahead>
				<wd-list-input name="Mesoklima" label="Mesoklima" [(model)]="data.extendedHeader.mesoklima"></wd-list-input>
				<!-- Substratfeuchte und Klimastufe werden hier nur uebernommen und lassen sich
				     nicht eintragen (die Substratfeuchte rechnet die App, die Klimastufe steht
				     unter Naturraum). Sie stehen deshalb ohne Rahmen da - ein Rahmen behauptet
				     sonst ein Eingabefeld (Nutzer-Entscheidung 11.09.2026). -->
				<wd-text-input class="nur-anzeige" name="Substratfeuchte" label="Substratfeuchte" [(model)]="data.header.substratFeuchte"></wd-text-input>
				<wd-typeahead class="nur-anzeige" name="KlimastufeNeu" label="Klimastufe" [model]="klimastufeAnzeige(data.extendedHeader.klimaStufe)" placement="top"></wd-typeahead>
			</div>
		</div>

		<!-- Bemerkungen: ohne graue Beschriftungsspalte - das Wort steht schon
		     in der Abschnittsueberschrift darueber (Nutzer-Entscheidung 11.09.2026). -->
		<div class="form-section-header">Bemerkungen</div>
		<div class="form-row">
			<div class="form-input-cell full-width">
				<wd-multiline-text-input name="Bemerkungen" [(model)]="data.header.bemerkungen"></wd-multiline-text-input>
			</div>
		</div>
	</div>
</bp-hl-area-container>
